import { capitalize } from "@/utils/utils"

export const getLocalStringDate = (date: Date, options = {
  weekday: 'long',
  year: 'numeric',
  month: 'long',
  day: 'numeric'
}) =>{
   return date.toLocaleString('fr-FR', options);
}

export const getLocalStringDateShort = (date:string) =>{
  const parts = new Date(date).toLocaleString('fr-FR', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  }).split(" ")
  parts[1] = capitalize(parts[1]).slice(0, 3)
  return parts.join(" ");
}

export const getLocalStringDateMY = (date:string) =>{
  return capitalize(new Date(date).toLocaleString('fr-FR', {
    year: 'numeric',
    month: 'long',
  }))
}

export const getLocalStringDateDMY = (date: string, options = {
  year: 'numeric',
  month: 'long',
  day: 'numeric'
}) =>{
  const parts = new Date(date).toLocaleString('fr-FR', options).split(" ")
  parts[1] = capitalize(parts[1])
  return parts.join(" ");
}

export const getLocalStringDateTime = (timestamp: number) =>{
  return new Date(timestamp).toLocaleString('fr-FR', {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  }).split(" ").join(" à ");
}

export const getLocalNumericDateDMY = (date: string, options = {
  year: 'numeric',
  month: 'numeric',
  day: 'numeric'
}) =>{
  return new Date(date).toLocaleString('fr-FR', options).split(" ");
}

//
// year: 'numeric',
// month: 'numeric',
// day: 'numeric',
// hour: '2-digit',
// minute: '2-digit',
// second: '2-digit'